import styled from 'styled-components';
import { Text } from 'components';
import { colorVariables } from 'theme/variables';
import mediaQueries from './mediaQueries';

export const MovieThumbStyled = styled.div`
  position: relative;
  cursor: pointer;
  width: 100%;
`;

export const WrapperTop = styled.div`
  ${mediaQueries};
  position: relative;
  background-color: ${colorVariables.white_lightgainsboro};
  width: 100%;
  height: calc(((100vw - 66px) / 3) / 16 * 9);

  ${MovieThumbStyled}:hover & {
    &:after {
      opacity: 1;
      visibility: visible;
    }
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.75);
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
  }
`;

export const TimeSeeker = styled.div`
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  display: block;
  height: 2px;
  transform: scaleX(0.8);
  transform-origin: 0 0;
  transition: transform 0.1s;
  background-color: ${colorVariables.blue_smalt};
`;

export const StyledImage = styled.img`
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
`;

export const TextWrapBottom = styled.div`
  position: relative;
  margin-top: 3px;
`;

export const StyledTextBottom = styled(Text)`
  display: block;
  height: 55px;
  line-height: 18px;
  width: 100%;
  overflow: hidden;

  ${MovieThumbStyled}:hover & {
    color: ${colorVariables.blue_navyblue};
  }
`;

export const TextWrapCurrent = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  padding-bottom: 10px;
  padding-top: 15%;
  width: 100%;
  text-align: center;
  z-index: 1;
  box-shadow: inset 0px -32px 30px -10px rgba(0, 0, 0, 0.8);
`;

export const StyledCurrentText = styled(Text)`
  ${MovieThumbStyled}:hover & {
    color: white;
  }
`;

export const IconWrap = styled.div`
  position: absolute;
  top: calc(50% + 2px);
  left: calc(50% + 2px);
  transform: translate(-50%, -50%);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease;
  z-index: 999;

  ${MovieThumbStyled}:hover & {
    opacity: 1;
    visibility: visible;
    &:after {
      opacity: 1;
      visibility: visible;
    }
  }
`;
